import { blockRegistry } from '@sarnia/shared';
import { editorStore, useEditorSelector } from './editorStore';
import { Icon } from '../components/ui/Icon';
import ThemePanel from './ThemePanel';
import InspectorFields from './inspectorFields';

export default function Inspector() {
  const site = useEditorSelector((state) => state.site);
  const selectedBlockId = useEditorSelector((state) => state.selectedBlockId);
  const selectedPanel = useEditorSelector((state) => state.selectedPanel);

  if (selectedPanel === 'theme') {
    return <ThemePanel />;
  }

  if (!site) {
    return (
      <div className="inspector-empty">
        <Icon name="mouse" size={28} />
        <p>Select a block on the page to edit it</p>
      </div>
    );
  }

  const block = site.blocks.find((item) => item.id === selectedBlockId);
  if (!block) {
    return (
      <div className="inspector-empty">
        <Icon name="mouse" size={28} />
        <p>Select a block on the page to edit it</p>
      </div>
    );
  }

  const fields = blockRegistry[block.type]?.inspector ?? [];
  const label = blockRegistry[block.type]?.label ?? block.type;
  const styleable = !['header', 'footer', 'spacer', 'cta', 'designed'].includes(block.type);

  return (
    <div className="inspector-panel">
      <div className="inspector-heading">
        <div className="inspector-title">
          <strong>{label}</strong>
        </div>
        <div className="inspector-heading-actions">
          <button
            type="button"
            className="inspector-heading-icon"
            title="Duplicate block"
            aria-label="Duplicate block"
            onClick={() => editorStore.duplicateBlock(block.id)}
          >
            <Icon name="copy" size={15} />
          </button>
          <button
            type="button"
            className="inspector-heading-icon"
            title="Delete block"
            aria-label="Delete block"
            onClick={() => editorStore.removeBlock(block.id)}
          >
            <Icon name="trash" size={15} />
          </button>
        </div>
      </div>
      {fields.length === 0 ? (
        <div className="inspector-empty">This block has no editable properties.</div>
      ) : (
        fields.map((field) => (
          <InspectorFields
            key={field.key}
            blockId={block.id}
            props={block.props as unknown as Record<string, unknown>}
            field={field}
            onChange={(patch) => editorStore.updateBlockProps(block.id, patch)}
          />
        ))
      )}
      {styleable ? (
        <section className="inspector-style" aria-label="Section style">
          <h4 className="inspector-style__title">Section style</h4>
          <label className="inspector-row">
            <span className="inspector-label">Background</span>
            <select
              value={block.style?.background ?? 'none'}
              onChange={(event) => editorStore.updateBlockStyle(block.id, { background: event.target.value as 'none' | 'surface' | 'tint' | 'accent' })}
            >
              <option value="none">Page colour</option>
              <option value="surface">Panel (cards colour)</option>
              <option value="tint">Soft tint of your brand colour</option>
              <option value="accent">Bold brand colour</option>
            </select>
          </label>
          <label className="inspector-row">
            <span className="inspector-label">Spacing</span>
            <select
              value={block.style?.space ?? 'normal'}
              onChange={(event) => editorStore.updateBlockStyle(block.id, { space: event.target.value as 'compact' | 'normal' | 'roomy' })}
            >
              <option value="compact">Compact</option>
              <option value="normal">Normal</option>
              <option value="roomy">Roomy</option>
            </select>
          </label>
        </section>
      ) : null}
    </div>
  );
}
